<template>
  <div id="contenedor-tabla-listado-observaciones">
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <td v-for="header in headers" :key="header.value" class="font-weight-medium">
              {{ header.text }}
            </td>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in items">
            <template>
              <tr :key="item.id" class="font-weight-medium grey lighten-3">
                <td>
                  <v-btn @click="toggleDetails(item.id)" icon text>
                    <v-icon>
                      {{ isActive(item.id) ? "mdi-minus" : "mdi-plus" }}
                    </v-icon>
                  </v-btn>
                </td>
                <td>
                  {{ item.numero }}
                </td>
                <td>
                  {{ item.contrato ? item.contrato.numero : "" }}
                </td>
                <td>
                  {{ item.descripcion }}
                </td>
                <td>
                  <v-chip>
                    {{ item.detalles.length }}
                  </v-chip>
                </td>
                <td>
                  <v-chip small :color="getColorStatus(item.estatus)" dark>
                    {{ item.estatus }}
                    <v-icon right small v-if="item.estatus === 'SOLVENTADA'">
                      mdi-check
                    </v-icon>
                  </v-chip>
                </td>
                <td class="caption" style="text-align:right">

                   <v-tooltip max-width="400" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            v-if="mixValidaScopesActions(2)"
                            x-small
                            icon
                            rounded
                          >
                            <v-icon
                            v-if="item.comentarios !== ''
                            && item.comentarios !== null"
                            @click="botonEditarObservacionComentario(item)">
                              mdi-comment-text-outline
                            </v-icon>
                            <v-icon
                            v-if="item.comentarios === ''
                            || item.comentarios === null"
                            @click="botonEditarObservacionComentario(item)">
                              mdi-comment-plus-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span
                          v-if="item.comentarios !== ''
                          && item.comentarios !== null"
                          style="word-wrap: break-word;"
                        >
                          {{ item.comentarios }}
                        </span>
                    </v-tooltip>
                </td>
                <td></td>
                <td>
                  {{ new Date(`${item.fechaEstatus} 00:00:0`).toLocaleDateString('es-MX') }}
                </td>
                <td>
                  <v-btn v-if="mixValidaScopesActions(1)" x-small icon rounded>
                    <v-icon @click="botonAgregarDetalle(item)">
                      mdi-file-plus-outline
                    </v-icon>
                  </v-btn>
                  <v-btn v-if="mixValidaScopesActions(2)" x-small icon rounded>
                    <v-icon @click="botonEditarObservacion(item)">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <v-btn v-if="mixValidaScopesActions(3)" x-small icon rounded>
                    <v-icon @click="botonEliminarObservacion(item)">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
              <template v-for="(detalle, index) in item.detalles">
                <template>
                  <tr
                    v-show="isActive(item.id)"
                    :key="`detalles-${detalle.id}`"
                    class="text--secondary"
                  >
                    <td></td>
                    <td class="caption">
                      <span style="padding-left: 20px; display: block;">
                        {{ index + 1 }}
                      </span>
                    </td>
                    <td class="caption">
                      <span style="padding-left: 20px; display: block;" v-if="detalle.contrato">{{
                        detalle.contrato.numero
                      }}</span>
                    </td>
                    <td colspan="2" class="caption">
                      <span style="padding-left: 20px; display: block;">
                        {{ detalle.texto }}
                      </span>
                    </td>
                    <td colspan="2" class="caption" style="text-align:right">
                      <v-tooltip max-width="400" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            v-if="mixValidaScopesActions(2)"
                            x-small
                            icon
                            rounded
                          >
                            <v-icon
                            v-if="detalle.comentarios !== '' && detalle.comentarios !== null"
                            @click="botonEditarDetalleComentario(detalle)">
                              mdi-comment-text-outline
                            </v-icon>
                            <v-icon
                            v-if="detalle.comentarios === '' || detalle.comentarios === null"
                            @click="botonEditarDetalleComentario(detalle)">
                              mdi-comment-plus-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span
                          v-if="detalle.comentarios !== '' && detalle.comentarios !== null"
                          style="word-wrap: break-word;"
                        >
                          {{ detalle.comentarios }}
                        </span>
                      </v-tooltip>
                    </td>
                    <td>
                      <v-badge
                        :value="detalle.espesificaciones.length > 0"
                        :content="detalle.espesificaciones.length"
                        overlap>
                        <v-btn color="primary" icon @click="handleMostrarEspecificaciones(detalle)">
                          <v-icon>
                            {{ detalle.espesificaciones.length > 0
                              ? 'mdi-folder-file'
                              : 'mdi-folder-plus' }}
                          </v-icon>
                        </v-btn>
                      </v-badge>
                    </td>
                    <td></td>
                    <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            @click="agregarEtiqueta(detalle)"
                            icon
                            rounded
                          >
                            <v-icon>
                              mdi-plus
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          Agregar Etiqueta
                        </span>
                      </v-tooltip>
                      <v-btn v-if="mixValidaScopesActions(2)" x-small icon rounded>
                        <v-icon @click="botonEditarDetalle(detalle, item)">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                      <v-btn v-if="mixValidaScopesActions(3)" x-small icon rounded>
                        <v-icon @click="botonEliminarDetalle(detalle, item)">
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
                <template v-if="detalle.etiquetas.length > 0">
                  <tr v-show="isActive(item.id)" :key="`etiquetas-${detalle.id}`">
                    <td></td>
                    <td></td>
                    <td colspan="9">
                      <template v-for="etiqueta in detalle.etiquetas">
                        <template>
                          <v-hover v-model="etiqueta.hover" :key="etiqueta.id">
                            <v-badge
                              :value="etiqueta.hover || false"
                              color="grey"
                              icon="mdi-close"
                              overlap
                            >
                              <v-chip
                                @click="eliminarEtiqueta(etiqueta, detalle)"
                                small
                                class="ml-2"
                                :color="etiqueta.auditoriaEtiqueta.color"
                                :dark="etiqueta.auditoriaEtiqueta.esTextoClaro"
                              >
                                {{ etiqueta.auditoriaEtiqueta.descripcion }}
                              </v-chip>
                            </v-badge>
                          </v-hover>
                        </template>
                      </template>
                    </td>
                  </tr>
                </template>
              </template>
            </template>
          </template>
        </tbody>
      </template>
    </v-simple-table>
    <v-dialog
      v-if="!$apollo.loading && mostrarEditarObservacion"
      v-model="mostrarEditarObservacion"
      width="800px"
      persistent
    >
      <EditarObservacion
        v-on:cerrar="mostrarEditarObservacion = !mostrarEditarObservacion"
        :observacionEditar="estaObservacion"
      >
      </EditarObservacion>
    </v-dialog>
    <v-dialog
      v-if="!$apollo.loading && mostrarEliminarObservacion"
      v-model="mostrarEliminarObservacion"
      width="500px"
      persistent
    >
      <EliminarObservacion
        v-on:cerrar="mostrarEliminarObservacion = !mostrarEliminarObservacion"
        :observacion="estaObservacion"
      >
      </EliminarObservacion>
    </v-dialog>
    <v-dialog
      v-if="!$apollo.loading && mostrarAgregarDetalle"
      v-model="mostrarAgregarDetalle"
      width="800px"
      persistent
    >
      <NuevoDetalle
        v-on:cerrar="mostrarAgregarDetalle = !mostrarAgregarDetalle"
        :observacion="estaObservacion"
        :informe="informe"
      >
      </NuevoDetalle>
    </v-dialog>
    <v-dialog
      v-if="!$apollo.loading && mostrarEditarDetalle"
      v-model="mostrarEditarDetalle"
      width="800px"
      persistent
    >
      <div>Eidtar</div>
      <EditarDetalle
        v-on:cerrar="mostrarEditarDetalle = !mostrarEditarDetalle"
        :detalle="esteDetalle"
        :informe="informe"
        :observacion="estaObservacion"
      >
      </EditarDetalle>
    </v-dialog>
    <v-dialog
      v-if="!$apollo.loading && mostrarEliminarDetalle"
      v-model="mostrarEliminarDetalle"
      width="500px"
      persistent
    >
      <EliminarDetalle
        v-on:cerrar="mostrarEliminarDetalle = !mostrarEliminarDetalle"
        :detalle="esteDetalle"
        :observacion="estaObservacion"
      >
      </EliminarDetalle>
    </v-dialog>
    <v-dialog
      v-if="!$apollo.loading && mostrarEditarObservacionComentario"
      v-model="mostrarEditarObservacionComentario"
      width="800px"
      persistent
      scrollable
    >
      <EditarObservacionComentario
        v-on:cerrar="mostrarEditarObservacionComentario = !mostrarEditarObservacionComentario"
        :observacionEditar="estaObservacion"
      >
      </EditarObservacionComentario>
    </v-dialog>
    <v-dialog
      v-if="!$apollo.loading && mostrarEditarDetalleComentario"
      v-model="mostrarEditarDetalleComentario"
      persistent
      scrollable
      width="800px"
    >
      <EditarDetalleComentario
        v-on:cerrar="mostrarEditarDetalleComentario = !mostrarEditarDetalleComentario"
        :detalle="esteDetalle"
      >
      </EditarDetalleComentario>
    </v-dialog>
    <v-dialog v-if="mostrarAgregarEtiquetas" v-model="mostrarAgregarEtiquetas" width="500">
      <AgregarAuditoriaEtiqueta
        :idReferencia="esteDetalle.id"
        :etiquetasAgregadas="esteDetalle.etiquetas"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
    <v-dialog v-if="estaEtiqueta" v-model="mostrarEliminarEtiqueta" width="500">
      <EliminarAuditoriaEtiqueta
        :etiquetaEliminar="estaEtiqueta"
        :etiquetasAgregadas="esteDetalle.etiquetas"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
    <v-dialog v-model="mostrarArchivosEspecificaciones" persistent width="650px">
      <v-card>
        <v-card-title>
          Especificaciones del Desglose
          <v-spacer></v-spacer>
          <v-btn icon @click="handleCerrarArchivosEspecificaciones">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <ListadoEspesificacions
            v-if="esteDetalle"
            :id-detalle="esteDetalle.id">
          </ListadoEspesificacions>
        </v-card-text>
        <v-card-actions>
          <custom-button
            iconText="mdi-plus"
            tipo="agregar"
            block
            @click="mostrarRegistrarSeguimiento = true"
          >
            Nuevo
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mostrarRegistrarSeguimiento" persistent scrollable width="650px">
      <RegistrarObservacionDetalleSeguimiento
        v-if="esteDetalle"
        :detalle="esteDetalle"
        :tipo="2"
        v-on:cerrar="mostrarRegistrarSeguimiento = false"
        v-on:success="refreshListado"
      >
      </RegistrarObservacionDetalleSeguimiento>
    </v-dialog>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import EditarObservacion from '@/components/administracion/auditorias/observaciones/Editar.vue';
import EliminarObservacion from '@/components/administracion/auditorias/observaciones/Eliminar.vue';
import EliminarDetalle from '@/components/administracion/auditorias/observaciones/detalles/Eliminar.vue';
import NuevoDetalle from '@/components/administracion/auditorias/observaciones/detalles/Nuevo.vue';
import EditarDetalle from '@/components/administracion/auditorias/observaciones/detalles/Editar.vue';
import EditarObservacionComentario from '@/components/administracion/auditorias/observaciones/EditarComentario.vue';
import EditarDetalleComentario from '@/components/administracion/auditorias/observaciones/detalles/EditarComentario.vue';
import AgregarAuditoriaEtiqueta from '@/components/administracion/auditorias/etiquetas/Agregar.vue';
import EliminarAuditoriaEtiqueta from '@/components/administracion/auditorias/etiquetas/Eliminar.vue';
import ListadoEspesificacions from '@/components/administracion/auditorias/observaciones/detalles/respuestas/ListadoEspesificaciones.vue';
import RegistrarObservacionDetalleSeguimiento from '@/components/administracion/auditorias/observaciones/detalles/respuestas/Nueva.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ListadoObservacionesAcordenonDetalles',
  props: {
    items: {
      type: Array,
      required: false,
    },
    informe: {
      type: Object,
      required: true,
    },
  },
  components: {
    ListadoEspesificacions,
    EditarObservacion,
    EliminarObservacion,
    NuevoDetalle,
    EliminarDetalle,
    EditarDetalle,
    CustomButton,
    EditarObservacionComentario,
    EditarDetalleComentario,
    AgregarAuditoriaEtiqueta,
    EliminarAuditoriaEtiqueta,
    RegistrarObservacionDetalleSeguimiento,
  },
  data() {
    return {
      activeRow: null,
      mostrarEditarObservacionComentario: false,
      mostrarEditarObservacion: false,
      mostrarEliminarObservacion: false,
      mostrarAgregarDetalle: false,
      mostrarEliminarDetalle: false,
      mostrarEditarDetalle: false,
      mostrarEditarDetalleComentario: false,
      mostrarAgregarEtiquetas: false,
      mostrarArchivosEspecificaciones: false,
      mostrarRegistrarSeguimiento: false,
      estaObservacion: {},
      esteDetalle: {},
      estaEtiqueta: null,
      headers: [
        {
          text: '',
          value: 'toggle',
          sortable: false,
        },
        {
          text: 'Número',
          value: 'numero',
          align: 'left',
          sortable: true,
        },
        {
          text: '# Contrato',
          value: 'numeroContrato',
          sortable: false,
        },
        {
          text: 'Observación',
          value: 'descripcion',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Desglose',
          value: 'desglose',
          align: 'center',
          sortable: true,
        },
        {
          text: 'Estatus',
          value: 'estatus',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Comentario',
          value: 'comentario',
          align: 'right',
          sortable: false,
        },
        {
          text: 'Especif.',
          value: 'espesificaciones',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Fecha Estatus',
          value: 'fechaEstatus',
          align: 'left',
          sortable: true,
        },
        {
          text: '',
          value: 'acciones',
          align: 'end',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    agregarObservacionDetalle(observacion) {
      eventBus.$emit('agregar-detalle-observacion', observacion);
    },
    toggleDetails(row) {
      this.activeRow = this.activeRow === row ? null : row;
    },
    isActive(row) {
      return this.activeRow === row;
    },
    getColorStatus(estatus) {
      switch (estatus) {
        case 'PENDIENTE':
          return 'red darken-1';
        case 'POR RESPONDER':
          return 'orange';
        case 'RESPUESTA ENVIADA PARCIAL':
          return 'info';
        case 'RESPUESTA ENVIADA COMPLETA':
          return 'success';
        case 'SOLVENTADA':
          return 'green darken-1';
        default:
          return 'warning';
      }
    },
    botonEditarDetalleComentario(detalle) {
      this.esteDetalle = detalle || {};
      if (this.esteDetalle && this.esteDetalle.id) this.mostrarEditarDetalleComentario = true;
    },
    botonEditarObservacionComentario(observacion) {
      this.estaObservacion = observacion || {};
      if (this.estaObservacion && this.estaObservacion.id) {
        this.mostrarEditarObservacionComentario = true;
      }
    },
    botonEditarObservacion(observacion) {
      this.estaObservacion = observacion;
      this.mostrarEditarObservacion = true;
    },
    botonEliminarObservacion(observacion) {
      this.estaObservacion = observacion;
      this.mostrarEliminarObservacion = true;
    },
    botonAgregarDetalle(observacion) {
      this.estaObservacion = observacion;
      this.mostrarAgregarDetalle = true;
    },
    botonEliminarDetalle(detalle, observacion) {
      this.esteDetalle = detalle;
      this.estaObservacion = observacion;
      this.mostrarEliminarDetalle = true;
    },
    botonEditarDetalle(detalle, observacion) {
      this.estaObservacion = observacion;
      this.esteDetalle = detalle;
      this.mostrarEditarDetalle = true;
    },
    agregarEtiqueta(detalle) {
      this.esteDetalle = detalle;
      this.mostrarAgregarEtiquetas = true;
    },
    eliminarEtiqueta(etiqueta, detalle) {
      this.estaEtiqueta = etiqueta;
      this.esteDetalle = detalle;
      this.mostrarEliminarEtiqueta = true;
    },
    cerrarVentana() {
      this.mostrarAgregarEtiquetas = false;
      this.mostrarEliminarEtiqueta = false;
      this.estaEtiqueta = null;
      this.esteDetalle = {};
    },
    handleMostrarEspecificaciones(detalle) {
      this.esteDetalle = detalle;
      this.mostrarArchivosEspecificaciones = true;
    },
    handleCerrarArchivosEspecificaciones() {
      this.mostrarArchivosEspecificaciones = false;
      this.esteDetalle = {};
    },
    refreshListado() {
      eventBus.$emit('refresh-listado-observaciones');
    },
  },
};
</script>

<style scoped>
.obervacion-indent td {
  padding-left: 10px;
}
</style>
